import * as Yup from "yup";

// Mirrors RegisterUserValidationClass on the api
export const CreateUserFormValidation = Yup.object({
    email: Yup.string()
        .email("Please enter a valid email address.")
        .required("Email is required"),
    password: Yup.string()
        .min(8, "Password must be at least 8 characters long.")
        .matches(
            /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/,
            "Password must include at least one uppercase letter, one number, and one special character."
        )
        .required("Password is required"),
});
